// extracted by css-extract-rspack-plugin
export default {"formStepsWrapper":"_cf3617ba","headerWrapper":"_e6d91c12","divider":"_6e3caf9f","formError":"_4459d070"};